
import { Injectable } from '@angular/core';
import CryptoJS from 'crypto-js';
import { ExternalSettings } from 'src/app/common/services/external-settings/external-settings.interface';
import { ExternalSettingsService } from 'src/app/common/services/external-settings/external-settings.service';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  private externalSettings !: ExternalSettings

  constructor(private srvES: ExternalSettingsService) {
    this.srvES.externalSettings$.subscribe((externalSettings) => { this.externalSettings = externalSettings });
  }

  public isSupported() {
    return (typeof (Storage) !== "undefined");
  }

  public set(key: LocalStorageType, value: string) {
    localStorage.setItem(key, this.encrypt(key, value));
  }

  public has(key: LocalStorageType) {
    let data = localStorage.getItem(key);
    return (data !== null);
  }

  public get(key: LocalStorageType, defaultValue: string = "") {
    let data = localStorage.getItem(key);
    if (data === null) { return defaultValue; }
    return this.decrypt(key, data);
  }

  public pop(key: LocalStorageType, defaultValue: string = "") {
    let data = this.get(key, defaultValue);
    this.remove(key);
    return data;
  }

  public remove(key: LocalStorageType) {
    localStorage.removeItem(key);
  }

  public clearAllData() {
    localStorage.clear();
  }

  private encrypt(key: LocalStorageType, txt: string): string {
    if (!this.isSecure(key)) { return txt; }
    let encPass = this.externalSettings.web.ecnPass || "";
    return CryptoJS.AES.encrypt(txt, encPass).toString();
  }

  private decrypt(key: LocalStorageType, txtToDecrypt: string) {
    if (!this.isSecure(key)) { return txtToDecrypt; }
    let encPass = this.externalSettings.web.ecnPass || "";
    return CryptoJS.AES.decrypt(txtToDecrypt, encPass).toString(CryptoJS.enc.Utf8);
  }

  /**
   * Define which keys do not require encryption
   */
  private isSecure(key: LocalStorageType): boolean {
    switch (key) {
      case LocalStorageType.LANGUAGE:
        return false;
      default:
        return true;
    }
  }

}

// https://blog.jscrambler.com/working-with-angular-local-storage

export const enum LocalStorageType {
  LANGUAGE = "LANGUAGE",
  REMEMBER_ME = "REMEMBER_ME",
}
